import React from 'react';
import PropTypes from 'prop-types';

const LinksList = ({ items, onClick, fieldName, type }) => (
  <ul className="guides__links">
    {items?.map((item, index) => (
      <li className="guides__links-item" key={fieldName + index}>
        {item.type !== 'Section' && (
          <a
            href="# "
            className={`link link-${type}`}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onClick(item);
            }}
          >
            {type === 'categories' && <span className="fas fa-file-alt categories-icon" />}
            <span className="name">{item[fieldName]}</span>
            {type === 'names' && <span className="fas fa-chevron-right names-icon" />}
          </a>
        )}
        {item.type === 'Section' && <div className="section-title">{item[fieldName]}</div>}
      </li>
    ))}
  </ul>
);

LinksList.propTypes = {
  items: PropTypes.array,
  onClick: PropTypes.func,
  fieldName: PropTypes.string,
  type: PropTypes.string,
};

export default LinksList;
